import { Component, ComponentRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';

import { Equipment, Plan, QuoteModel } from '@bytel/bytel-sales';

import { ConfigurationService } from '@services/configuration.service';
import { Ftth3ClicsService } from '@services/ftth3-clics.service';
import { MainCartService } from '@services/main-cart.service';

import { Subscription } from 'rxjs';

import { ProductMapping } from '../../../catalog/product-mapping';
import { NavigateToDirective } from '../../../common/directives/navigate-to.directive';
import { EquipmentBlockDirective } from './equipment-block.directive';
import { EquipmentComponent } from './equipment/equipment.component';

@Component({
    selector: 'checkout-equipment-block',
    templateUrl: './equipment-block.component.html',
    styleUrl: 'equipment-block.component.scss',
    standalone: true,
    imports: [NavigateToDirective, EquipmentBlockDirective],
})
export class EquipmentBlockComponent implements OnInit, OnDestroy {
    @ViewChild(EquipmentBlockDirective, { static: true }) subscriptionHost: EquipmentBlockDirective;
    @Input() public quoteIndex: number = 0;

    public equipment: Equipment;
    public cartQuoteSubscription: Subscription;
    public editUrl: string;
    public showDeleteButton: boolean = true;

    private cartService: MainCartService = inject(MainCartService);
    private configurationService: ConfigurationService = inject(ConfigurationService);
    private ftth3ClicsService: Ftth3ClicsService = inject(Ftth3ClicsService);

    public ngOnInit(): void {
        this.equipment = this._getQuote().getPrincipalProduct<Equipment>('Equipment');
        this._loadComponent();
        this._updateOnQuoteChange();
        const isRenewal: boolean = this._getQuote().isRenewal();
        const plan = this._getQuote().getPrincipalProduct<Plan>('Plan');
        const accessories = this._getQuote().getProductsByType('Accessory');
        const isAccessoryInAutoAdd = accessories?.some((accessory) =>
            plan?.autoAdd?.includes(accessory?.data?.gencode),
        );
        this.showDeleteButton = !isRenewal && !isAccessoryInAutoAdd;
        let wallUrl: string = this.equipment.wallurl;
        if (isRenewal) {
            wallUrl = 'renewal';
        }

        this.editUrl = this.configurationService.getData()?.global.wall[wallUrl];
    }

    public ngOnDestroy(): void {
        this.cartQuoteSubscription.unsubscribe();
    }

    public remove(): void {
        this.stopUsingFtth3Clics();
        this.cartService.removeProduct(this.equipment, this.quoteIndex).subscribe();
    }

    public stopUsingFtth3Clics(): void {
        this.ftth3ClicsService.stopUsingFtth3Clics();
    }

    /**
     *
     *
     * @memberof EquipmentBlockComponent
     */
    private _loadComponent(): void {
        const viewContainerRef: ViewContainerRef = this.subscriptionHost.viewContainerRef;
        viewContainerRef.clear();
        const component = ProductMapping.getComponent(this.equipment);
        const componentRef: ComponentRef<EquipmentComponent> = viewContainerRef.createComponent(component);
        componentRef.instance.quoteIndex = this.quoteIndex;
    }

    private _getQuote(): QuoteModel {
        return this.cartService.getQuote(this.quoteIndex);
    }

    /**
     *
     *
     * @private
     * @memberof EquipmentBlockComponent
     */
    private _updateOnQuoteChange(): void {
        this.cartQuoteSubscription = this.cartService.cartQuoteSubscription.subscribe((quoteIndex) => {
            const equipment: Equipment = this._getQuote().getPrincipalProduct<Equipment>('Equipment');
            if (equipment && quoteIndex === this.quoteIndex) {
                this.equipment = equipment;
                this._loadComponent();
            }
        });
    }
}
